<div class="dialog__wrapper">
  <form [formGroup]="formArray" (ngSubmit)="handleFormSubmit()">
    <div mat-dialog-title class="dialog__header-wrapper">
      <div class="dialog__header">
        <h4 class="dialog__title">
          Authorised Sender IDs for <strong>{{ data.opa.opaOrganisationName }}</strong>
        </h4>
        <button mat-dialog-close mat-icon-button>
          <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
        </button>
      </div>
      <p>Select the Sender IDs to authorise or deauthorise and click confirm</p>
      <mat-form-field subscriptSizing="dynamic" class="dialog__filter" *ngIf="!isFetching">
        <mat-label>Search...</mat-label>
        <input type="text" matInput [formControl]="filter" />
      </mat-form-field>
    </div>

    <mat-dialog-content>
      <div>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="senderIds">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sender ID Text</th>
            <td mat-cell *matCellDef="let element">
              <span [siAuthorisationStatus]="element">
                {{ element.senderIdText }}
              </span>
            </td>
          </ng-container>
  
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <div class="radio-select__container">
                <mat-slide-toggle [formControl]="getFormArrayControl(element)">
                  {{ getFormArrayControl(element).value ? OPAStatusDesc.Authorised : OPAStatusDesc.NotAuthorised }}
                </mat-slide-toggle>
              </div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
  
          <tr *matNoDataRow>
            <td colspan="3" *ngIf="!isFetching">Authorised Sender IDs list is empty</td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="TableConstants.dialogPageSize" aria-label="Page size"></mat-paginator>
        <div class="dialog__spinner">
          <div *comSpinner="isFetching; color: 'primary'; diameter: 30"></div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-stroked-button (click)="handleClose()" type="button" class="button--secondary button--pad-right">Close</button>
      <button mat-raised-button type="submit" [disabled]="disableSaveButton">Confirm</button>
    </mat-dialog-actions>
  </form>
</div>
